import React, { useRef, useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const PortfolioCarousel = ({ images, language }) => {
    const carouselRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const scroll = (direction) => {
        if (carouselRef.current) {
            const scrollAmount = carouselRef.current.offsetWidth * 0.8;
            carouselRef.current.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            });
        }
    };

    return (
        <section className="w-full py-16 bg-indigo-800 text-white relative">
            <div className="max-w-7xl mx-auto px-4">
                <h2 className="text-3xl font-bold mb-8 text-center">
                    {language === "English" ? "My Portfolio" : "Mi Portafolio"}
                </h2>

                <div className="relative">
                    {/* Scrollable Carousel */}
                    <div
                        ref={carouselRef}
                        className="flex overflow-x-scroll overflow-y-hidden space-x-4 md:space-x-6 scroll-smooth snap-x snap-mandatory pretty-scrollbar"
                    >
                        {images.map((img, index) => (
                            <div
                                key={index}
                                className="min-w-[90%] sm:min-w-[60%] md:min-w-[18%] flex-shrink-0 snap-center rounded-xl overflow-hidden shadow-lg bg-white cursor-pointer"
                                onClick={() => setSelectedImage(img)}
                            >
                                <img
                                    src={img.src}
                                    alt={img.alt || `Portfolio ${index + 1}`}
                                    className="w-full h-60 object-cover"
                                />
                            </div>
                        ))}
                    </div>

                    {/* Navigation Buttons */}
                    <button
                        onClick={() => scroll("left")}
                        className="hidden md:flex absolute left-0 top-1/2 transform -translate-y-1/2 bg-purple-700 text-white p-3 rounded-full shadow-lg hover:bg-indigo-600 transition z-10"
                    >
                        <ChevronLeft className="w-6 h-6" />
                    </button>

                    <button
                        onClick={() => scroll("right")}
                        className="hidden md:flex absolute right-0 top-1/2 transform -translate-y-1/2 bg-purple-700 text-white p-3 rounded-full shadow-lg hover:bg-indigo-600 transition z-10"
                    >
                        <ChevronRight className="w-6 h-6" />
                    </button>
                </div>
            </div>

            {/* Modal */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex justify-center items-center px-4 animate-fadeIn">
                    <div className="bg-gradient-to-br from-indigo-700 via-indigo-500 to-white rounded-2xl shadow-2xl max-w-3xl w-full p-6 relative text-black">
                        {/* Close Button */}
                        <button
                            className="absolute top-4 right-4 text-red-500 hover:text-gray-200 transition"
                            onClick={() => setSelectedImage(null)}
                        >
                            <X className="w-6 h-6" />
                        </button>

                        {/* Image */}
                        <div className="w-full max-h-[60vh] overflow-hidden flex justify-center mb-4 p-4 rounded-lg">
                            <img
                                src={selectedImage.src}
                                alt={selectedImage.title}
                                className="object-contain max-h-[60vh] w-auto"
                            />
                        </div>

                        {/* Title & Description */}
                        <h2 className="text-2xl font-bold mb-2 text-center text-black drop-shadow">
                            {selectedImage.title}
                        </h2>
                        <p className="text-black text-center drop-shadow">
                            {selectedImage.description}
                        </p>
                    </div>
                </div>
            )}
        </section>
    );
};

export default PortfolioCarousel;
